import React from "react";
import { motion } from "framer-motion";

const IMG = "https://images.unsplash.com/photo-1766299231533-27fb998d1a6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
  return (
    <div>
      <section className="relative overflow-hidden border-b border-[#F5F2EA]/10">
        <div className="absolute inset-0">
          <img src={IMG} alt="MOIRÉ editorial" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] to-[#0D0D0D]/50" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 py-32">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <p className="font-sans text-[10px] tracking-luxe uppercase text-[#C8A97E]">About MOIRÉ</p>
            <h1 className="font-serif text-5xl md:text-7xl text-[#F5F2EA] mt-4 leading-[0.95]">A private stylist,<br />always in reach.</h1>
          </motion.div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 md:px-8 py-24 space-y-10">
        <p className="font-serif text-2xl md:text-3xl text-[#F5F2EA] leading-relaxed">
          MOIRÉ answers one everyday question — <span className="text-[#C8A97E]">what should I wear with this?</span>
        </p>
        <p className="font-sans text-base text-[#F5F2EA]/70 leading-relaxed">
          Photograph a piece you love. MOIRÉ reads its colour, texture and mood, then returns the pairings that work —
          ranked, explained, and ready to wear. No colour theory. No second-guessing. Just informed styling guidance,
          the way a good stylist would offer it.
        </p>
        <p className="font-sans text-base text-[#F5F2EA]/70 leading-relaxed">
          Fashion is creative and personal. MOIRÉ never dictates — it recommends, and you remain free to break every rule.
        </p>
        <div className="gold-line" />
        <div>
          <p className="font-sans text-[10px] tracking-luxe uppercase text-[#8A8170]">Powered by</p>
          <p className="font-serif text-3xl text-[#F5F2EA] mt-2">Kendi Collections</p>
          <p className="font-serif italic text-lg text-[#F5F2EA]/70 mt-1">Classic fashion for the classic person.</p>
        </div>
      </section>
    </div>
  );
}
